import { useContext, useEffect, useRef, useState } from "react";

import { api_without_cancellation } from "../../../../api/api";
import { CaseNavigatorModalContext } from "../../CaseNavigatorModalContext";
import { setEqualColumnWidthsInjury } from "../../../../Utils/helper";

const InjuryBodyPartTab = ({
  caseTypes,
  currentFilter,
  rowCount,
  onCaseTypeAvailabilityChange,
}) => {
  const [InjuriesData, setInjuriesData] = useState([]);
  const [injuryColumns, setInjuryColumns] = useState([]);
  const { handleShowModal } = useContext(CaseNavigatorModalContext);
  // const fetchInjuriesData = async (currentFilter2) => {
  //   const response = await api_without_cancellation.get(
  //     "/api/navigator/navigator_injuries_data/",
  //     currentFilter2
  //       ? {
  //           params: {
  //             [currentFilter2.type]: currentFilter2.name || "",
  //           },
  //         }
  //       : {}
  //   );
  //   setInjuriesData(response.data.case_injuries_data);
  // };
  const fetchInjuriesData = async (currentFilter2) => {
    try {
      const res = await api_without_cancellation.get(
        "/api/navigator/navigator_injuries_data/",
        currentFilter2
          ? {
              params: {
                [currentFilter2.type]: currentFilter2.name || "",
              },
            }
          : {}
      );

      const data = res?.data?.case_injuries_data ?? [];
      setInjuriesData(data);
      setInjuryColumns(res?.data?.injury_columns ?? []);
      onCaseTypeAvailabilityChange?.(
        new Set(
          data
            .filter((row) => row.some((item) => item.count > 0))
            .flatMap((row) => {
              const item = row[0];
              const keys = [];
              if (item?.case_type_id !== null && item?.case_type_id !== undefined) {
                keys.push(`id:${item.case_type_id}`);
              }
              if (item?.case_type) {
                keys.push(`name:${item.case_type.trim().toLowerCase()}`);
              }
              return keys;
            })
        )
      );
    } catch (error) {
      console.error("Failed to fetch injuries data:", error);
      setInjuriesData([]);
      setInjuryColumns([]);
      onCaseTypeAvailabilityChange?.(new Set());
    }
  };

  useEffect(() => {
    fetchInjuriesData(currentFilter);
  }, [currentFilter]);

  // const getSpanText = (spanClass) => {
  //   switch (spanClass) {
  //     case "span_1_D":
  //       return "between 0 Day and 1 Day";
  //     case "span_2_D":
  //       return "between 1 Day and 2 Day";
  //     case "span_3_D":
  //       return "between 2 Day and 3 Day";
  //     case "span_1_Wk":
  //       return "between 3 Day and 1 Week";
  //     case "span_2_Wks":
  //       return "between 1 Week and 2 Weeks";
  //     case "span_1_Mo":
  //       return "between 2 Week and 1 Month";
  //     case "span_2_Mos":
  //       return "between 1 Month and 2 Months";
  //     case "span_3_Mos":
  //       return "between 2 Months and 3 Months";
  //     case "span_6_Mos":
  //       return "between 3 Months and 6 Months";
  //     case "span_1_Yr":
  //       return "between 6 Months and 1 Year";
  //     case "span_2_Yrs":
  //       return "between 1 Year and 2 Years";
  //     case "span_3_Yrs":
  //       return "between 2 Years and 3 Years";
  //     case "span_5_Yrs":
  //       return "between 3 Years and 5 Years";
  //     case "span_greater_5_Yrs":
  //       return "more than 5 Years";
  //     default:
  //       return "";
  //   }
  // };
  const openModal = (caseType, tabValue, caseTypeId) => () => {
    // const span = getSpanText(tabValue);
    // const typeText = caseType === "" ? "All Case Types" : caseType;
    // const stageText = activeStage === "all_stage" ? "All Stages" : activeStage;
    // const statusText = activeStatus === "all_status" ? "All Statuses" : activeStatus;

    // const headerString = `${typeText} Cases sorted by ${stageText}, ${statusText} with Case Age ${span}`;
    // const span = getSpanText(tabValue);
    const formatTabValue = (tabVal) => {
      if (tabVal.endsWith("_case")) {
        tabVal = tabVal.replace("_case", ""); // Remove '_case' suffix
      }
      return tabVal.replace(/_/g, " "); // Replace underscores with spaces
    };
    const typeText = caseType === "" ? "All Case Types" : caseType;
    const hasFilter = currentFilter && currentFilter.name;
    // const headerString =

    const headerString = hasFilter
      ? `${typeText} Cases filtered by ${currentFilter.name} for ${formatTabValue(tabValue)}`
      : `${typeText} cases for ${formatTabValue(tabValue)}.`;

    handleShowModal({
      caseType: caseType,
      // Status: "All Statuses",
      // Stage: "All Stages",
      CurrentFilter: currentFilter,
      tabName: "Injury",
      tabValue: tabValue,
      headerString: headerString,
      caseTypeId: caseTypeId,
      range: formatTabValue(tabValue),
    });
  };
  const tableRef = useRef(null);
  const aggregateRow = InjuriesData.find((row) => !row[0]?.case_type);
  const orderedCaseRows = caseTypes.map(
    (caseType) =>
      InjuriesData.find((row) => row[0]?.case_type === caseType.name) ||
      injuryColumns.map((injuryName) => ({
        count: 0,
        case_type: caseType.name,
        injury_name: injuryName,
      }))
  );
  const displayRows = aggregateRow ? [aggregateRow, ...orderedCaseRows] : orderedCaseRows;

  useEffect(() => {
    const handleResize = () => setEqualColumnWidthsInjury(tableRef);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [InjuriesData, injuryColumns]);

  return (
    <>
      <div>
        <table
          ref={tableRef}
          className="table res_tab table-navi-different table-responsive ms-0 equal-column-width-table navigator-standard-table-header"
        >
          <tbody className=" Index-width-webkit-fill-available-display-inline-table">
            <tr className="thead">
              {injuryColumns.map((injuryName) => (
                <th key={injuryName} title={injuryName}>
                  {injuryName}
                </th>
              ))}
            </tr>
            {displayRows
              .filter((case_data) => case_data.length > 0)
              .map((case_data, index) => (
                <tr key={index} className="h-25px">
                  {injuryColumns.map((injuryName) => {
                    const individual_data = case_data.find(
                      (injury) => injury.injury_name === injuryName
                    );
                    const count = individual_data?.count ?? 0;

                    return count > 0 ? (
                      <td
                        key={injuryName}
                        className="h-25px cursor-pointer onHoverNewThings text-center"
                        onClick={openModal(
                          individual_data.case_type,
                          injuryName,
                          individual_data?.case_type_id || ""
                        )}
                      >
                        <p
                          className="fw-bold"
                          data-span-class={injuryName}
                          // data-status-class={activeStatus}
                          // data-stage-class={activeStage}
                          data-casetype={
                            individual_data.case_type
                              ? individual_data.case_type.replace(/\s/g, "")
                              : ""
                          }
                        >
                          {count}
                        </p>
                      </td>
                    ) : (
                      <td
                        key={injuryName}
                        className="h-25px onHoverNewThings cursor-pointer text-center"
                      >
                        <p
                          className="text-grey"
                          data-span-class={injuryName}
                          // data-status-class={activeStatus}
                          // data-stage-class={activeStage}
                          data-casetype={
                            individual_data?.case_type
                              ? individual_data.case_type.replace(/\s/g, "")
                              : ""
                          }
                        >
                          {/* {individual_data.count} */}
                        </p>
                      </td>
                    );
                  })}
                </tr>
              ))}
            {Array.from({ length: Math.max(0, rowCount - displayRows.length + 1) }).map(
              (_, rowIndex) => (
                <tr key={`injury-empty-${rowIndex}`}>
                  {Array.from({ length: injuryColumns.length }).map((_, colIndex) => (
                    <td key={colIndex} style={{ height: "25px" }} className="onHoverNewThings" />
                  ))}
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default InjuryBodyPartTab;
